//pokeball bg
export default ({ fill = "#FFFFFF", style = {}, className = "", ...rest }) => {
  return (
    <>
      <svg
        width="316.33423px"
        height="319.1px"
        viewBox="0 0 316.33423 319.1"
        version="1.1"
        style={style}
        className={className}
        {...rest}
      >
        <path
          d="M79.6792 137.65L0.107727 137.65C10.7813 59.8952 77.4796 0 158.167 0C238.854 0 305.553 59.895 316.226 137.65L236.755 137.65C227.205 103.249 195.66 78 158.217 78C120.775 78 89.2292 103.249 79.6792 137.65L79.6792 137.65ZM118.717 159.1C118.717 137.561 136.178 120.1 157.717 120.1C179.256 120.1 196.717 137.561 196.717 159.1C196.717 180.639 179.256 198.1 157.717 198.1C136.178 198.1 118.717 180.639 118.717 159.1L118.717 159.1ZM236.946 180.65L316.334 180.65C306.01 258.794 239.131 319.1 158.167 319.1C77.2031 319.1 10.3245 258.794 0 180.65L79.4883 180.65C88.8024 215.408 120.521 241 158.217 241C195.913 241 227.632 215.408 236.946 180.65L236.946 180.65Z"
          id="Vector"
          fill={fill}
          fillRule="evenodd"
          stroke="none"
        />
      </svg>
    </>
  );
};
